module.exports = __webpack_public_path__ + "static/img/all-banner1.57047c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/all-banner1.png
// module id = 8AvH
// module chunks = 1